export type {IProgressBarProps} from './IProgressBarProps';
export type {IProgressBarState} from './IProgressBarState';
export {XProgressBar} from './XProgressBar';